import type { AccountInfo } from "./types.js";

/**
 * Herkenbaarheid bij meerdere mailboxen. Wie Rulido en Okidoky naast elkaar
 * heeft, moet in één oogopslag zien in welke mailbox hij zit — anders
 * beantwoordt hij een klant van het ene bedrijf vanuit het andere.
 */

/**
 * Vaste kleur per positie: de eerste mailbox houdt het merkoranje, zodat een
 * klant met één mailbox niets ziet veranderen. Allemaal donker genoeg voor
 * witte letters, in beide thema's.
 */
const COLORS = ["var(--brand)", "#1f6feb", "#128a5b", "#6b4ee6", "#b3261e", "#0e7490"];

export function accountColor(accounts: readonly AccountInfo[], id: string): string {
  const index = accounts.findIndex((a) => a.id === id);
  return COLORS[Math.max(0, index) % COLORS.length] ?? "var(--brand)";
}

/** "info@okidoky.nl" → "Okidoky": de bedrijfsnaam zit bijna altijd in het domein. */
export function accountName(address: string): string {
  const domain = address.split("@")[1] ?? address;
  const name = domain.split(".")[0] ?? domain;
  return name.charAt(0).toUpperCase() + name.slice(1);
}

/**
 * Letter in het rondje. Met één mailbox de eerste letter van het adres, zoals
 * altijd; met meerdere die van het bedrijf — "info@" begint anders overal met
 * een I.
 */
export function accountInitial(address: string, multiple: boolean): string {
  const source = multiple ? accountName(address) : address;
  return source.charAt(0).toUpperCase() || "?";
}
